import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-menu-section',
  standalone: true,
  templateUrl: './ui-menu-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiMenuSectionComponent {
  title = input.required<string>();
}
